var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "back_calendar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 34,
    height: 34,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_37",
    "data-name": "Mask Group 37",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_angle-double-left_",
    "data-name": "FontAwsome (angle-double-left)",
    d: "M31.25,100.684l4.5-4.5a.791.791,0,0,1,1.122,0l.748.748a.791.791,0,0,1,0,1.122l-3.187,3.194,3.19,3.19a.791.791,0,0,1,0,1.122l-.748.751a.791.791,0,0,1-1.122,0l-4.5-4.5A.792.792,0,0,1,31.25,100.684ZM24.9,101.809l4.5,4.5a.791.791,0,0,0,1.122,0l.748-.748a.791.791,0,0,0,0-1.122l-3.187-3.194,3.19-3.19a.791.791,0,0,0,0-1.122l-.748-.751a.791.791,0,0,0-1.122,0l-4.5,4.5A.792.792,0,0,0,24.9,101.809Z",
    transform: "translate(-14.662 -83.95)",
    fill: "#b1cb79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.c20f28cb84a0c98c61bd018f677584e6.svg";
export { ForwardRef as ReactComponent };